import { useCurrentUser } from '../../../../../shared/features/session/components/CurrentUserProvider';

/** What the signed-in user may do on a truck's page. UX only: the server stays the authority. */
export function useTruckPermissions() {
  const { state } = useCurrentUser();
  const has = (permission: string) => state.status === 'authenticated' && state.user.permissions.includes(permission);

  return {
    isKnown: state.status === 'authenticated',
    canManageTruck: has('truck.manage'),
    canManageDocuments: has('document.manage'),
    canViewMaintenance: has('maintenance.view'),
  };
}
